/**
 * Lightweight logger that no-ops in production.
 * Replaces scattered isDev() checks and raw console.log calls.
 *
 * Usage:
 *   import { logger } from '@/shared/lib/logger'
 *   logger.debug('Loading vehicles:', count)  // only in dev
 *   logger.warn('Missing field:', name)        // only in dev
 *   logger.error('API failed:', err)           // always (error reporting)
 *
 * This file is the one legitimate place in `src/` to reference `console.*`
 * directly — it is the logger implementation itself. The eslint-disable
 * comments below reflect that.
 */

/* eslint-disable no-console */

const isDev = () =>
  import.meta.env.DEV || import.meta.env.NODE_ENV === 'development'

export const logger = {
  /** Debug info — dev only, stripped in production. */
  debug: (...args: unknown[]) => {
    if (isDev()) console.log(...args)
  },

  /** Warnings — dev only. */
  warn: (...args: unknown[]) => {
    if (isDev()) console.warn(...args)
  },

  /** Errors — always logged (these are legitimate error reporting). */
  error: (...args: unknown[]) => {
    console.error(...args)
  },
}

/* eslint-enable no-console */
